export default {
	guidesSet (state, payload) {
		state.guides = payload
	},
	coursesSet (state, payload) {
		state.courses = payload
	},
	guidesSetTotal (state, payload) {
		state.totalGuides = payload
	},
	coursesSetTotal (state, payload) {
		state.totalCourses = payload
	},
}
